import { RouteProps } from "react-router"
import InputAlcoholNumber from "../../features/Tablet/features/InputAlcoholNumber/InputAlcoholNumber"
import TabletLogin from "../../features/Tablet/features/Login/Login"
import LoginByQRCode from "../../features/Tablet/features/LoginByQRCode/LoginByQRCode"
import SelectAlcoholCheck from "../../features/Tablet/features/SelectAlcoholCheck/SelectAlcoholCheck"
import SelectHiroSippeiSuiminBusoku from "../../features/Tablet/features/SelectHiroSippeiSuiminBusoku/SelectHiroSippeiSuiminBusoku"
import SelectMenkyoUmu from "../../features/Tablet/features/SelectMenkyoUmu/SelectMenkyoUmu"
import SelectMode from "../../features/Tablet/features/SelectMode/SelectMode"
import SelectNitizyoTenken from "../../features/Tablet/features/SelectNitizyoTenken/SelectNitizyoTenken"
import SelectSyukiObi from "../../features/Tablet/features/SelectSyukiObi/SelectSyukiObi"
import SelectTenkoBasyo from "../../features/Tablet/features/SelectTenkoBasyo/SelectTenkoBasyo"
import SelectTenkoTiming from "../../features/Tablet/features/SelectTenkoTiming/SelectTenkoTiming"
import SelectTenkoType from "../../features/Tablet/features/SelectTenkoType/SelectTenkoType"
import SelectWeather from "../../features/Tablet/features/SelectWeather/SelectWeather"
import SelectZyomuinByICCard from "../../features/Tablet/features/SelectZyomuinByICCard/SelectZyomuinByICCard"
import SelectZyomuinByNumber from "../../features/Tablet/features/SelectZyomuinByNumber/SelectZyomuinByNumber"
import SiziZiko from "../../features/Tablet/features/SiziZiko/SiziZiko"
import SonotaHokoku from "../../features/Tablet/features/SonotaHokoku/SonotaHokoku"
import TenkoList from "../../features/Tablet/features/TenkoList/TenkoList"

export type TTabletPage = {
  機能名: string
  表示名?: string
  Route: RouteProps
}

export const directory = "/tablet"

export const loginPage = {
  機能名: "ログイン",
  表示名: "ログイン",
  Route: { exact: true, path: directory + "/login", component: TabletLogin },
} as const

export const loginByQRCodePage = {
  機能名: "QRコードログイン",
  表示名: "QRコードログイン",
  Route: {
    exact: true,
    path: directory + "/login/qrcode",
    component: LoginByQRCode,
  },
} as const
export const selectModePage = {
  機能名: "機能選択",
  表示名: "機能選択",
  Route: { exact: true, path: directory + "/select", component: SelectMode },
} as const

export const selectWeatherPage = {
  機能名: "天候選択",
  表示名: "天候選択",
  Route: {
    exact: true,
    path: directory + "/weather/select",
    component: SelectWeather,
  },
} as const

export const tenkoListPage = {
  機能名: "点呼一覧",
  表示名: "点呼一覧",
  Route: { exact: true, path: directory + "/tenko/list", component: TenkoList },
} as const

//#region 点呼

export const selectTenkoTypePage = {
  機能名: "点呼方式選択",
  表示名: "点呼方式選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/type",
    component: SelectTenkoType,
  },
} as const

export const selectSyainByICCardPage = {
  機能名: "点呼対象ICカード選択",
  表示名: "点呼対象ICカード選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/syain/card",
    component: SelectZyomuinByICCard,
  },
} as const

export const selectSyainByNumberPage = {
  機能名: "点呼対象テンキー選択",
  表示名: "点呼対象テンキー選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/syain/number",
    component: SelectZyomuinByNumber,
  },
} as const

export const selectTenkoTimingPage = {
  機能名: "点呼時点選択",
  表示名: "点呼時点選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/timing",
    component: SelectTenkoTiming,
  },
} as const

export const selectTenkoBasyoPage = {
  機能名: "点呼場所選択",
  表示名: "点呼場所選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/place",
    component: SelectTenkoBasyo,
  },
} as const

export const selectNitizyoTenkenPage = {
  機能名: "点呼日常点検選択",
  表示名: "点呼日常点検選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/nitizyotenken",
    component: SelectNitizyoTenken,
  },
} as const

export const selectHiroSippeiSuiminBusokuPage = {
  機能名: "点呼睡眠疾病睡眠不足選択",
  表示名: "点呼睡眠疾病睡眠不足選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/taityo",
    component: SelectHiroSippeiSuiminBusoku,
  },
} as const

export const selectMenkyoUmuPage = {
  機能名: "点呼免許有無選択",
  表示名: "点呼免許有無選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/menkyo",
    component: SelectMenkyoUmu,
  },
} as const

export const selectAlcoholCheckPage = {
  機能名: "点呼アルコール測定有無選択",
  表示名: "点呼アルコール測定有無選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/alcohol/check",
    component: SelectAlcoholCheck,
  },
} as const

export const selectSyukiObiPage = {
  機能名: "点呼酒気帯び有無選択",
  表示名: "点呼酒気帯び有無選択",
  Route: {
    exact: true,
    path: directory + "/tenko/select/syukiobi",
    component: SelectSyukiObi,
  },
} as const

export const inputAlcoholNumberPage = {
  機能名: "点呼アルコール測定入力",
  表示名: "点呼アルコール測定入力",
  Route: {
    exact: true,
    path: directory + "/tenko/input/alcohol",
    component: InputAlcoholNumber,
  },
} as const

export const siziZikoPage = {
  機能名: "点呼指示事項確認",
  表示名: "点呼指示事項確認",
  Route: {
    exact: true,
    path: directory + "/tenko/check/siziziko",
    component: SiziZiko,
  },
} as const

export const sonotaHokokuPage = {
  機能名: "点呼その他報告事項確認",
  表示名: "点呼その他報告事項確認",
  Route: {
    exact: true,
    path: directory + "/tenko/check/sonotahokoku",
    component: SonotaHokoku,
  },
} as const

//#endregion

export const allPages: TTabletPage[] = [
  selectModePage,
  selectWeatherPage,
  tenkoListPage,
  // 点呼個別画面
  selectTenkoTypePage,
  selectSyainByICCardPage,
  selectSyainByNumberPage,
  selectTenkoTimingPage,
  selectTenkoBasyoPage,
  selectNitizyoTenkenPage,
  selectHiroSippeiSuiminBusokuPage,
  selectMenkyoUmuPage,
  selectAlcoholCheckPage,
  selectSyukiObiPage,
  inputAlcoholNumberPage,
  siziZikoPage,
  sonotaHokokuPage,
]
